import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-work-anniversaey-report',
  templateUrl: './work-anniversaey-report.component.html',
  styleUrls: ['./work-anniversaey-report.component.css']
})
export class WorkAnniversaeyReportComponent implements OnInit {

  workAnniversaryReport=[];

  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYear = currentDate.getFullYear();
    
    this.getWorkAnniversaryDetails(currentMonth, currentYear);
  }

  getWorkAnniversaryDetails(month: number, year: number) {
    this.masterDataService
        .getWorkAnniversaryReport(month,year)
        .subscribe((res:any) => {
          this.workAnniversaryReport = res;
        });
  }

}
